module.exports = __webpack_public_path__ + "7ab2defa9223c6f9a39f731db484dadb.fbx";